// extracted by mini-css-extract-plugin
export default {"container":"user-placeholder_container__2vjHF","paragraph":"user-placeholder_paragraph__19Mkz","visible":"user-placeholder_visible__1iBJs"};